// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"daee3c32","101":"54e869e3","540":"9cd37fd7","787":"98fdc0d8"}[chunkId] + ".chunk.js";
};